import React from 'react';
export interface PortfolioItem {
  id: number;
  title: string;
  description: string;
  shortDescription?: string;
  image: string;
  category: string | string[];
  client: string;
  year: number;
  videoUrl?: string;
  galleryImages?: {
    url: string;
    alt: string;
  }[];
  animationUrl?: string;
  comingSoon?: boolean;
}
export const portfolioItems: PortfolioItem[] = [{
  id: 20,
  title: 'btf Logo Animation Concept',
  shortDescription: 'Kinetic Logo Animation für die bildundtonfabrik',
  description: `Die bildundtonfabrik ist eine der erfolgreichsten Kölner Videoproduktionsfirma wenn es um Netflix-Serien, ZDF-Shows oder hochwertige Dokumentationen geht. Da ich seit mehreren Jahren Fan des Unternehmens und deren Projekten bin, habe ich mir die Aufgabe gesetzt, das Logo des Unternehmens mit "Kinetic Animationen" zu animieren. Dadurch konnte ich meine Skills was flüssige und ansprechende Animationen angeht weiter ausbauen.
Hinweis:
Dieses Projekt ist ein rein konzeptioneller Entwurf. Ich habe keinerlei Rechte an der Marke und dem Logo der „bildundtonfabrik".`,
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/b8u7LUUYsDxWNeXrLTxrnt/BTF_thumnbail.png',
  animationUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5XSxmbiEd3Y6uWocVbBsHz/BTF_Gif.gif',
  category: 'Motion Design',
  client: 'Privat',
  year: 2025
}, {
  id: 21,
  title: 'Cro – Ein Portrait des Künstlers',
  shortDescription: 'Eine persönliche Hommage an den Künstler Cro',
  description: `Über das Projekt\n\nCro ist für mich einer der prägendsten Künstler, die mich auf meinem Weg dorthin begleitet haben, wo ich heute bin. Ob Easy – meine erste CD –, tru. als mein Lieblingsalbum oder sein neuer Vibe, mit dem er dem Studioalbum trip eine ganz eigene Sprache gegeben hat: Ich bin Fan!\n\nUm meine persönliche Geschichte mit Cro zu erzählen, habe ich 2019 ein kurzes Video geschnitten. Es war mein erstes Projekt, das ich innerhalb eines Tages gescriptet, vertont, geschnitten und hochgeladen habe.`,
  image: 'https://img.youtube.com/vi/P7bE-bLlqyU/maxresdefault.jpg',
  category: 'Video',
  client: 'Privat',
  year: 2019,
  videoUrl: 'https://www.youtube.com/embed/P7bE-bLlqyU'
}, {
  id: 19,
  title: 'NKALIS',
  shortDescription: 'Konzertfotografie von Nkalis im Tsunami Club Köln.',
  description: '',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iWx9UGKF5oQ3izwKLsTdwJ/DSC06874.jpg',
  category: 'Photo',
  client: 'NKALIS',
  year: 2023,
  galleryImages: [{
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/baxNHy9UvhQkbRpW1qURUY/DSC06114.jpg',
    alt: 'Performer with microphone in blue lighting'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fDidrCfXB8345ZN67UiyWj/DSC06288.jpg',
    alt: 'Dynamic black and white shot of performer with microphone'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6rSJNR1NHBEgqEmNw1aPzM/DSC06705.jpg',
    alt: 'Performer in red lighting holding microphone'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mMcxaaMMyWhsaXCDcMgQMn/DSC06815.jpg',
    alt: 'Guitarist performing in red lighting'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iWx9UGKF5oQ3izwKLsTdwJ/DSC06874.jpg',
    alt: 'Energetic performance shot with performer in red lighting'
  }]
}, {
  id: 18,
  title: 'Tutoolio LMS Erklärvideo',
  shortDescription: 'Animiertes Erklärvideo für das Multimandanten-LMS von Tutoolio',
  description: 'Dieses Erklärvideo visualisiert mit einfachen optischen Elementen und verspielten Animationen, wie das Multimandanten-LMS von Tutoolio funktioniert. Dabei durfte ich das Projekt in Eigenregie leiten, war für Storyboard, Animation, Assetrecherche und Sounddesign verantwortlich.',
  image: 'https://img.youtube.com/vi/6QWjAAlw1QQ/maxresdefault.jpg',
  category: 'Motion Design',
  client: 'TUTOOLIO',
  year: 2024,
  videoUrl: 'https://www.youtube.com/embed/6QWjAAlw1QQ'
}, {
  id: 17,
  title: 'Calum Scott',
  shortDescription: 'Konzertfotografie von Calum Scott auf dem Kunst!Rasen Bonn',
  description: '',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jrP4Rs7qnutbEXwNhe5N1R/DSC03218.jpg',
  category: 'Photo',
  client: 'Kunst!Rasen',
  year: 2023,
  galleryImages: [{
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cZ1SFX9XZ15ZPvwbnRyLen/DSC03041.jpg',
    alt: 'Concert lighting and silhouette in dramatic black and white'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dFmeRHzGznyxdKaLQTcqWG/DSC03059.jpg',
    alt: 'Performer with arms spread wide in black and white'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ekP6BjW8hBGBXgbmTCDkrU/DSC03189.jpg',
    alt: 'Emotional performance moment in color with blue lighting'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jrP4Rs7qnutbEXwNhe5N1R/DSC03218.jpg',
    alt: 'Performer reaching upward with dramatic lighting'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eAgfvQ5A5siFAHhVmUFb4w/DSC03250.jpg',
    alt: 'Wide stage shot with dramatic red lighting'
  }]
}, {
  id: 16,
  title: 'Icon 3 Finale',
  shortDescription: 'Fotografie des ICON 3 Finale',
  description: '',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4wt8ya86QcKhCN9Xoxn1ZZ/DSC05538-2-2.jpg',
  category: 'Photo',
  client: 'ICONxMADE',
  year: 2022,
  galleryImages: [{
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9ybWw5dzTXjXQvrhyXrSKW/DSC05113-2.jpg',
    alt: 'Concert performer in green lighting with crowd'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cbXGCkqfziC1VDGHiUJHdC/DSC05144-2.jpg',
    alt: 'Back view of performers with crowd holding phone lights'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bxE5ePadrY8nHgfP1NQT7S/DSC05172-2.jpg',
    alt: 'Concert attendee in red cap enjoying the show'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mGAntTiJ5rM8AtjrMam8hU/DSC05192-2.jpg',
    alt: 'Crowd enjoying the concert with phone lights'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ptC9xvDmp5fJ6DqjABeFid/DSC05538-2.jpg',
    alt: 'Performer with pyrotechnic effects'
  }]
}, {
  id: 15,
  title: 'Anny Ogrezeanu',
  shortDescription: 'Konzertfotografie von Anny Ogrezeanu auf dem Kunst!Rasen Bonn',
  description: '',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gRpyV3QV9odVLUuTswfSX1/DSC02846.jpg',
  category: 'Photo',
  client: 'Kunstrasen',
  year: 2023,
  galleryImages: [{
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gRpyV3QV9odVLUuTswfSX1/DSC02846.jpg',
    alt: 'Anny Ogrezeanu performing 1'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/neWxLuicL7opLG7TiWAYrJ/DSC02853.jpg',
    alt: 'Anny Ogrezeanu performing 2'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8718QdJj9g76XooSiyBd85/DSC02861.jpg',
    alt: 'Anny Ogrezeanu performing 3'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2ugi2wPyK7HWkWxWFBB5C4/DSC02863.jpg',
    alt: 'Anny Ogrezeanu performing 4'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/no5vKog9j2kyrewYEogiTY/DSC02959.jpg',
    alt: 'Anny Ogrezeanu performing 5'
  }]
}, {
  id: 14,
  title: 'Musikvideo 13. Stock',
  shortDescription: 'BTS photography for Eric Langenfeld.',
  description: '',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/517iitH7LCmN75QVxHTRVs/IMG_0946.png',
  category: 'Photo',
  client: 'Eric Langenfeld',
  year: 2023,
  galleryImages: [{
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kgLbUewuGQx6EVuYr4WWtf/DSC09203.jpg',
    alt: 'Behind the scenes 1'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eYyS6F6CsuGaGv7XphhgMT/DSC09221.jpg',
    alt: 'Behind the scenes 2'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kQFijrVtjapzb5nM4VmAKN/DSC09225.jpg',
    alt: 'Behind the scenes 3'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/c7wsxUSVbJ8zmfA66WtfYi/DSC09366.jpg',
    alt: 'Behind the scenes 4'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/n5upuZGdWaLiJcSJMkJNbh/IMG_0946.jpg',
    alt: 'Behind the scenes 5'
  }]
}, {
  id: 13,
  title: 'Tyren Davis – Fight the Crying',
  shortDescription: 'Musikvideoproduktion im Studio für Tyren Davis und Imperator Studio',
  description: `Nachdem ich mich mit dem Musikvideo für "Somehow" das erste Mal als Videograf im Bereich Musikvideoproduktion beweisen konnte, durfte ich mit dem Anschlussprojekt "Fight the crying" meine ersten Erfahrungen als Videograf in einem Studio machen. Mit einem wundervollen Team unter der Leitung von Imperator Studios gelang es uns, aus fünf einzelnen Performanceaufnahmen eine dynamische Szenerie in der Minimalistik zu erzeugen.`,
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/srogfXeN17gwb8Kvu8N6PF/Tyren_davis_raw-2.jpg',
  category: 'Video',
  client: 'Imperator Studios',
  year: 2022,
  videoUrl: 'https://www.youtube.com/embed/FAvsDPjsn0w'
}, {
  id: 1,
  title: 'Bachelorprojekt',
  shortDescription: 'Videoessay über eine Reise an die Westküste der USA',
  description: `„Erwartungen und Erfüllung" – eine dokumentarische Reise durch die USA, die mehr über mich verraten hat, als ich erwartet hätte. Über Jahre hinweg hatte ich mir Bilder von diesem Land gemacht, nur um vor Ort festzustellen, dass die Realität oft anders – und manchmal noch beeindruckender – ist.`,
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ncfPKPpWXHvgBVZEidZcDt/yzqMQ7OqmGA-HD.jpg',
  category: ['Video', 'Motion Design'],
  client: 'Abschlussarbeit',
  year: 2024,
  videoUrl: 'https://www.youtube.com/embed/yzqMQ7OqmGA'
}, {
  id: 10,
  title: 'Rüdell Social Media',
  shortDescription: 'Social Media Strategie und Podcast-Produktion für Parfümerie Rüdell',
  description: `Für die Parfümerie Rüdell und Parfum.de habe ich den Social-Media-Auftritt entwickelt und produziert. Das Projekt beinhaltete die Gestaltung einer visuellen Strategie, die die Markenidentität und die Zielgruppe perfekt anspricht. Zudem durfte ich den Podcast „Achtung Duftgefahr!" konzipieren und produzieren. Dabei lag mein Fokus auf der Kreation eines ansprechenden Formats, das nicht nur spannende Inhalte rund um Parfüms bietet, sondern auch die Marke authentisch und unterhaltsam präsentiert.`,
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6GUxGwsQ16ciN1XfQqMYAg/IMG_0223.jpg',
  category: 'Motion Design',
  client: 'Parfümerie Rüdell',
  year: 2024,
  videoUrl: 'https://www.youtube.com/embed/MZaEvd9srU8'
}];